import { InteractiveRoomItem } from "$/game/prefabs/InteractiveRoomItem.ts";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class BasketInteractiveObject extends InteractiveRoomItem {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(
      myScene,
      x,
      y,
      myScene.atlas,
      myScene.keys.assets.sprites.items.basket,
    );

    this.setOnClickCallback(() => {
    });
  }

  override destroy(): void {
    // this.scene.tweens.killTweensOf(this);
    super.destroy();
  }
}
